export default __webpack_public_path__ + "3aaeadb23c6d81611b1d17d5bd1be4e7.jpg";